import api from '@/utils/api'

const defaultMeaageFrom = {
  type: 0,
  content: '',
  targetMessageId: 0,   //目标信息ID
  targetCommentId: 0    //目标评论ID
}
const defaultTargetData = {
  commentId: 0,
  commentList: [],
  content: "",
  createdAt: 0,
  empAvatar: "",
  empId: 0,
  empIsAuthor: null,
  empName: "",
  targetCommentId: null,
  targetEmpId: 0,
  targetEmpName: "",
  targetMessageId: 0,
  type: 0,
  updatedAt: 0,
}
const state = {
  detailVisible: false,
  messageId: '',
  detailData: {
    authorId: null,
    authorName: "",
    authorState: null,
    commentCount: 0,
    content: "",
    coverUrl: null,
    createdAt: null,
    messageId: null,
    rejectionReason: null,
    reviewedAt: null,
    reviewerId: null,
    status: null,
    type: null,
    unread: false,
    updatedAt: null,
    url: null,
    viewCount: 0,
    authorAvatar: null
  },
  messageList: [],
  messageFrom: {
    ...defaultMeaageFrom
  },
  targetData: {
    ...defaultTargetData
  },
  showTargetList:[]
}

const getters = {
  messageCount(state) {
    return state.messageList.length
  },
  targetCommentData(state) {
    return state.messageList.find(item => item.commentId === state.messageFrom.targetCommentId)
  }
}

const mutations = {
  setDetailVisible(state, value) {
    state.detailVisible = value
  },
  setMessageId(state, value) {
    state.messageId = value
  },
  setDetailData(state, value) {
    state.detailData = value
  },
  setMessageCommentList(state, value) {
    state.messageList = value
  },
  setMessageFrom(state, value) {
    state.messageFrom = { ...state.messageFrom, ...value }
  },
  setTargetData(state, value) {
    state.targetData = { ...state.targetData, ...value }
  },
  setShowTargetList(state, value) {
    state.showTargetList = value
  }
}

const actions = {
  async detailOnShow({ commit, state, dispatch }, messageId) {
    commit('setMessageId', messageId)
    commit('setMessageFrom', { targetMessageId: messageId })
    await dispatch('getPlazaMessageDetailFn')
    await dispatch('getMessageCommentList')
    commit('setDetailVisible', true)
  },
  detailOnClose({ commit, state, dispatch }) {
    commit('setDetailVisible', false)
    commit('setMessageId', '')
    commit('setMessageCommentList', [])
    commit('setMessageFrom', { ...defaultMeaageFrom })
    commit('setTargetData', { ...defaultTargetData })
    commit('setShowTargetList', [])
  },
  async getPlazaMessageDetailFn({ commit, state },) {
    const { status, data } = await api.getPlazaMessageDetail({ messageId: state.messageId })
    if (status === 200) {
      commit('setDetailData', data)
    }
  },
  async getMessageCommentList({ commit, state },) {
    const { status, data } = await api.getMessageCommentList({ messageId: state.messageId })
    if (status === 200) {
      commit('setMessageCommentList', data)
    }
  },
  async postMessageComment({ dispatch, state,commit }) {
    const data = await api.postMessageComment(state.messageFrom)
    const { status, message } = data
    if (status === 200) {
      dispatch('getMessageCommentList')
      dispatch('getPlazaMessageDetailFn')
      console.log(888,state.targetData)
      let id = state.targetData.targetCommentId ||  state.targetData.commentId 
      commit('setShowTargetList', [id])
    }
    return data
  },
  // 设置评论目标
  setTarget({ commit }, item) {
    let type = 0;
    if (item.type === 0) type = 1;
    if (item.type === 1) type = 2;
    commit('setMessageFrom', { targetCommentId: item.commentId, type })
    commit('setTargetData', item)
  },
  clearTarget({ commit }) {
    commit('setTargetData', { ...defaultTargetData })
    const {targetMessageId,...parm} = defaultMeaageFrom
    commit('setMessageFrom', { ...parm })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
